export const makeAvatarName = (name: string) => {
  return name ? name.split(' ').slice(0, 2).map((word) => word[0]) : '';
}
